module.exports = __webpack_public_path__ + "static/media/hover2.3af08b99.gif";